module.exports = __webpack_public_path__ + "static/media/tendericon03@3x.e0e8fbbc.png";